export default "__VITE_ASSET__f4e541cc__"